export default __webpack_public_path__ + "static/media/doctor2.22df2a09.jpg";